import { ROUTES } from '@utils/routes';

export default function (variant = {}) {
  const id = Number(variant?.cataloguePostId ?? variant?.id);
  return translatePath(ROUTES.CODE.CATALOGUE, slugify(id, catalogueDisplayName(variant)));
}
